module.exports = __webpack_public_path__ + "media/v2/components/shared/InstagramCarousel/mockPicts/1-d1f914bd27f7a7d8d2d62f9a0768d0a9.png";